import api from '../services/api';
import { $Q, $Qll } from '../utils/query-selector';
import { dataToggle, toggleDataActive } from '../utils/toggle-dataset';
import { sliderUpsell, sliderReassurance } from './slider-swiper';
import {
  updateCartItems,
  updatetotalPrice,
  updateUpsell,
  updateCartbutton,
  updatePriceItem,
  updateCountCart,
  showErrorStock,
  hideErrorStock
} from './update-cart';

import { barProgress } from '../utils/bar-progress';
import { validationTC } from '../utils/validate-cart';

const CART_SECTION = 'side-cart-new,cart-page';

barProgress($Q('#progress-bar-data'));
sliderUpsell();
sliderReassurance();
validationTC();

/**
 * Add products in cart
 * @param {event} event -Event submit from add to cart form
 * @param {event} event -Event submit from add to cart form
 */
const addProducts = async (event) => {
  let itemId = 0;

  for (const input of event.target) {
    if (input.name === 'id') {
      itemId = input.value;
    }
  }

  const cartParams = {
    items: [
      {
        id: itemId,
        quantity: 1,
      },
    ],
    sections: CART_SECTION,
  };

  const { sections } = await api.addToCart(cartParams);
  if (!sections) return null;

  if (event.target.dataset.form !== 'upsell') {
    dataToggle($Q('#shopify-section-side-cart-new'), true);
  }
  updateCartItems(sections['side-cart-new']);
  updateCartbutton(sections['side-cart-new']);
  updatetotalPrice(sections['side-cart-new']);
  updateUpsell(sections['side-cart-new']);
  updateCountCart(sections['side-cart-new']);
};

const submitForm = (form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    addProducts(e);
  });
};

/**
 * Remove disable attribute when form add event listener
 *
 * @param {Array} List of buttons
 *
 * */
export const btnEnable = (buttons) => {
  buttons.forEach((button) => {
    if (button.getAttribute('data-available') === 'true') {
      button.removeAttribute('disabled');
    }
  });
};

/**
 * Listen if add to cart form is submited
 * if add to cart form is submited add products in cart
 *
 * @param {string} formQuery - className reference in form add-to-cart
 *
 * To active this feature - ADD className 'add-cart-js' in form product
 * */
export const btnAddToCart = (formQuery) => {
  const addForms = $Qll(formQuery);

  if (addForms != null) {
    addForms.forEach((form) => {
      submitForm(form);

      // Enable Button for send form
      btnEnable(
        document.querySelectorAll(`button[form="${form.getAttribute('id')}"]`)
      );
    });
  }
};

/**
 * Replace en element with a spinner
 * @param {String} element
 */
const addSpinner = (element) => {
  $Q(element).innerHTML = '<div class="loading"></div>';
};

/**
 * Validate if stock is out
 * @param {Array} Array of objects in cart
 * @param {Object} Cart params
 */
const outStockValidation = (cartItems, { quantity, line }, id) => {
  const item = cartItems[line - 1];
  if (item.quantity !== parseInt(quantity)) {
    showErrorStock(id, quantity);
  }
};

/**
 * Update quantity for each item in cart
 * @param {number} id Product ID
 * @param {number} quantity new quantity
 */
export const updateCart = async (line, quantity, id) => {
  hideErrorStock(id)
  addSpinner(`#price-${id}`);
  document.querySelector('.cart-loader').classList.add('active');
  const cartParams = {
    line,
    quantity,
    sections: CART_SECTION,
  };

  const { sections = null, items = [] } = await api.changeCart(cartParams);

  if (!sections) return null;

  if (Number(quantity) === 0) {
    updateCartItems(sections['side-cart-new']);
    updateCartbutton(sections['side-cart-new']);
    updatetotalPrice(sections['side-cart-new']);
    updateUpsell(sections['side-cart-new']);
  } else {
    updatePriceItem(sections['side-cart-new'], id);
    updateCartbutton(sections['side-cart-new']);
    updatetotalPrice(sections['side-cart-new']);

    outStockValidation(items, cartParams, id);
  }
  updateCountCart(sections['side-cart-new']);

  document.querySelector('.cart-loader').classList.remove('active');
};

/**
 * Event onChange in the cart item
 */

export const onChangeItemCart = () => {
  $Qll('.item-cart-js').forEach((input) => {
    input.addEventListener('change', function () {
      updateCart(this.dataset.index, this.value, this.id);
    });
  });
};

/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteItem = () => {
  const deleteIcon = $Qll('.item-delete');

  if (deleteIcon) {
    deleteIcon.forEach((element) => {
      const {
        dataset: { id, index },
      } = element;
      element.addEventListener('click', () => {
        updateCart(index, 0, `${id}-${index}`);
      });
    });
  }
};

/**
 * Open and close side cart with various buttons
 */
export const openCloseCart = () => {
  const cartContainer = $Q('.cart');
  cartContainer.setAttribute('data-active', 'false');

  toggleDataActive('.cart-close', '#shopify-section-side-cart-new', {
    overlay: true,
  });
  toggleDataActive('.cart-close-mobile', '#shopify-section-side-cart-new', {
    overlay: true,
  });

  toggleDataActive('.button-cart', '#shopify-section-side-cart-new', {
    overlay: true,
  });
  toggleDataActive('.button-cart-mobile', '#shopify-section-side-cart-new', {
    overlay: true,
  });
  toggleDataActive('.button-cart-scroll', '#shopify-section-side-cart-new', {
    overlay: true,
  });
};
